import * as React from "react";
import { Switch } from "@/components/ui";
import { VideoProjectDetail } from "@/interfaces";

interface Props {
  videoProject: VideoProjectDetail;
  disabled: boolean;
  showHashtagToggle: boolean;
  onChangeField: (field: keyof VideoProjectDetail, value: any) => void;
}

export const EditorCaptionSettings: React.FC<Props> = ({
  videoProject,
  disabled,
  showHashtagToggle,
  onChangeField,
}) => {
  return (
    <div className="flex flex-col gap-4 border-l-2 border-slate-200 ml-2 pl-4">
      {showHashtagToggle && (
        <div className="flex flex-row items-center gap-3">
          <Switch
            id="allowHashtags"
            disabled={disabled}
            checked={!!videoProject.allowPlayerHashtags}
            onCheckedChange={checked => onChangeField("allowPlayerHashtags", checked)}
          />
          <div className="flex flex-col text-left select-none">
            <label htmlFor="allowHashtags" className="text-sm font-semibold text-slate-800 cursor-pointer">
              Include player's hashtags
            </label>
          </div>
        </div>
      )}

      <div className="flex flex-row items-center gap-3">
        <Switch
          id="allowShortLink"
          disabled={disabled}
          checked={!!videoProject.allowShortLink}
          onCheckedChange={checked => onChangeField("allowShortLink", checked)}
        />
        <div className="flex flex-col text-left select-none">
          <label htmlFor="allowShortLink" className="text-sm font-semibold text-slate-800 cursor-pointer">
            Include player's short link
          </label>
        </div>
      </div>

      <div className="flex flex-row items-center gap-3">
        <Switch
          id="allowComplianceDisclaimer"
          disabled={disabled}
          checked={!!videoProject.allowComplianceDisclaimer}
          onCheckedChange={checked => onChangeField("allowComplianceDisclaimer", checked)}
        />
        <div className="flex flex-col text-left select-none">
          <label htmlFor="allowComplianceDisclaimer" className="text-sm font-semibold text-slate-800 cursor-pointer">
            Include Compliance Disclaimer
          </label>
        </div>
      </div>
    </div>
  );
};
